import Shuffle from 'shufflejs';
import $ from 'jquery';
// import axios from 'axios';

$( document ).ready( function() {
  var portfolioGrid = document.querySelector( '#portfolio-grid' );
  if( portfolioGrid ) {
    var shuffleTown = window.Shuffle;
    var myShuffle = new Shuffle( portfolioGrid, {
      itemSelector: '.grid-item--portfolio'
    } );
    var filterBox = document.querySelector( '.filter-box' );
    Array.from(filterBox.children).forEach((child, index) => {
      child.addEventListener( "click", function() {
        let category = this.dataset.cat;
        if( category === 'reset' ) {
          myShuffle.filter();
          $( '.filter-box__select--current' ).removeClass('filter-box__select--current');
        } else {
          myShuffle.filter( category );
          $( '.filter-box__select--current' ).removeClass('filter-box__select--current');
          $( this ).addClass('filter-box__select--current');
        }
      });
    } );

  }

} );
